module.exports = __webpack_public_path__ + "static/media/arrow-left-black.370af476.svg";